var confEnv = {
  pdb_api_url: 'http://pdb-api.erco.localhost',
  www_url: 'http://lightscout.erco.localhost',
  cookie_domain: 'localhost',
  download_service_url: 'http://download-service.erco.localhost',
  specsheet_service_url: 'http://specsheet-service.erco.localhost',
  translation_service_url: 'http://translation-service.erco.localhost',
  maintenance_banner_enabled: 'false',
};
